import { render, staticRenderFns } from "./NotUseDialog.vue?vue&type=template&id=d04a73d2&scoped=true"
import script from "./NotUseDialog.vue?vue&type=script&lang=ts"
export * from "./NotUseDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d04a73d2",
  null
  
)

export default component.exports